/* eslint-disable no-unused-expressions */
import { createSlice } from '@reduxjs/toolkit';
// api
import { getGroupTimeList, getInterviewUser, interviewTagList, getChangePassword, getConfig } from '../../api/interviewStage';
// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  editInfo: null,
  editLoading: false,
  // 面试时间列表
  interviewTimeList: [],
  timeListLoading: false,
  ChangRolearr: { total: 0, rows: [] },
  RoleTagId: null,
  openRole: '',
  parent: [],
  record: false
};

const slice = createSlice({
  name: 'apply',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    getInterviewTimeList(state, action) {
      state.timeListLoading = false;
      state.isShowViewTime = true;
      state.interviewTimeList = action.payload;
    },
    setTimeLoading(state, action) {
      state.timeListLoading = action.payload;
    },
    setEditInfo(state, action) {
      state.editLoading = false;
      state.editInfo = action.payload;
    },
    setEditLoading(state, action) {
      state.editLoading = action.payload;
    },
    setChangRolearr(state, action) {
      state.editLoading = false;
      state.ChangRolearr = {
        total: action.payload.length,
        rows: action.payload
      };
    },
    setRoleTagId(state, action) {
      state.editLoading = false;
      state.RoleTagId = action.payload;
    },
    setRecord(state, action) {
      state.editLoading = false;
      state.record = action.payload;
    },
    setOpenRole(state, action) {
      state.editLoading = false;
      state.openRole = action.payload;
    },
    setParent(state, action) {
      state.editLoading = false;
      state.parent = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

export const { setEditInfo, setRoleTagId, setOpenRole, setRecord } = slice.actions;

// ----------------------------------------------------------------------
// 获取面试时间列表
export function featchInterviewTimeList(params) {
  return async (dispatch) => {
    dispatch(slice.actions.setTimeLoading(true));
    try {
      const response = await getGroupTimeList(params);
      dispatch(slice.actions.getInterviewTimeList(response.rows));
    } catch (error) {
      // dispatch(slice.actions.getInterviewTimeListError());
      dispatch(slice.actions.setTimeLoading(false));
    }
  };
}

// 获取面试时间列表
export function featchInterviewUser(params) {
  return async (dispatch) => {
    dispatch(slice.actions.setEditLoading(true));
    try {
      const response = await getInterviewUser(params);
      dispatch(slice.actions.setEditInfo(response));
    } catch (error) {
      dispatch(slice.actions.setEditLoading(false));
    }
  };
}

// 更改角色
export function getInterviewTagList(params) {
  return async (dispatch) => {
    dispatch(slice.actions.setEditLoading(true));
    try {
      const response = await interviewTagList(params);
      dispatch(slice.actions.setChangRolearr(response));
    } catch (error) {
      dispatch(slice.actions.setEditLoading(false));
      dispatch(slice.actions.setChangRolearr([]));
    }
  };
}

// 修改賬戶密碼
export function setChangePassword({ callback, final, error, ...params }) {
  return async () => {
    try {
      await getChangePassword(params);
      callback();
      // dispatch(slice.actions.getSettingInfo(response));
    } catch (err) {
      console.error(err);
      error();
    }
    final();
  };
}

export function getParentConfig(params) {
  return async (dispatch) => {
    dispatch(slice.actions.setEditLoading(true));
    try {
      const response = await getConfig(params);
      dispatch(slice.actions.setParent(response));
    } catch (error) {
      dispatch(slice.actions.setEditLoading(false));
    }
  };
}